import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  Page, Stack,
  Card,
  Button,
  Modal,
  Form,
  TextStyle,
  DisplayText,
  Link,
  SkeletonBodyText,
  SkeletonThumbnail,
} from "@shopify/polaris";
import Dashboard from "./Dashboard";
import Br from "../../components/Br";
import { useHistory } from "react-router-dom";
import axios from "../../axios";
import { ShopContext } from "../../App";
import Notice from "../../components/Notice";
import PhoneNumberLib from "awesome-phonenumber";
import WhatsAppNumberForm from "../../components/WhatsAppNumber";
import _ from "lodash";
import { loadAutomations } from "../../utils";
import ChatWithUsIcon from "../../components/icons/ChatWithUs.svg";
import "../../App.css";
// Options for the language selector
export const options = [
  { label: "English", value: "en_US" },
  { label: "Portuguese", value: "pt_PT" },
  { label: "Spanish", value: "es_ES" },
  { label: "German", value: "de_DE" },
];

// WhatsApp number validator
export const validateWhatsAppNumber = (whatsAppNumber) => {
  if (whatsAppNumber.length <= 1) {
    return false;
  }

  let phoneLibObj = new PhoneNumberLib(`+${whatsAppNumber}`);
  if (!phoneLibObj.isMobile() || !phoneLibObj.isValid()) {
    return false;
  }
  return true;
};

const DashboardPage = () => {
  const config = useContext(ShopContext);
  const router = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [playDemoVideo, setPlayDemoVideo] = useState(false);
  const [playDemoVideoTwo, setPlayDemoVideoTwo] = useState(false);
  const [whatsAppNumber, setWhatsAppNumber] = useState("");
  const [languageCode, setLanguageCode] = useState("en_US");
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [noticeMessage, setNoticeMessage] = useState("");
  const [showNotice, setShowNotice] = useState(false);
  const [noticeType, setNoticeType] = useState("info");
  const [saving, setSaving] = useState(false);
  const handleSelectChange = (value) => setLanguageCode(value);
  const [loading, setLoading] = useState(false);
  const [shop, setShop] = useState({});
  const [dashboard, setDashboard] = useState({});
  const [automations, setAutomations] = useState([]);

  // Open the modal to get the WhatsApp number if it not exists
  useEffect(() => {
    axios
      .get(`/dashboard/store-settings`, {
        headers: {
          shopOrigin: config.shopOrigin,
          xShopHost: config.host,
        },
      })
      .then((response) => {
        if (!response.success) {
          setOpenModal(true);
        } else {
          loadAutomations(
            setShop,
            setLoading,
            setDashboard,
            setAutomations,
            config.shopOrigin,
            config.host
          );
        }
      })
      .catch(() => {
        setOpenModal(false);
      });
  }, []);

  // Submit the form
  const handleSubmit = useCallback(
    (_event) => {
      // Validations
      if (!validateWhatsAppNumber(whatsAppNumber)) {
        setPhoneNumberError(true);
        return false;
      }
      setSaving(true);

      // Update the store details
      let modifiedStoreDetails = {
        whatsapp_number: whatsAppNumber,
        language_code: languageCode,
      };

      axios
        .put(`/dashboard/store-settings/`, modifiedStoreDetails, {
          headers: {
            shopOrigin: config.shopOrigin,
            xShopHost: config.host,
          },
        })
        .then((response) => {
          setSaving(false);
          setOpenModal(false);
          setNoticeMessage(response.message);
          setNoticeType("success");
          setShowNotice(true);
          loadAutomations(
            setShop,
            setLoading,
            setDashboard,
            setAutomations,
            config.shopOrigin,
            config.host
          );
        })
        .catch((e) => {
          setSaving(false);
          alert("Failed to update the store details.");
        });
    },
    [whatsAppNumber, languageCode]
  );

  // Stats
  let totalSentMessages = _.get(dashboard, "total_sent_messages", 0);
  let totalDeliveredMessages = _.get(dashboard, "total_delivered_messages", 0);
  let totalOpenedMessages = _.get(dashboard, "total_opened_messages", 0);

  // Percentage Stats
  let totalDeliveredMessagesPercentage =
    totalSentMessages > 0
      ? (totalDeliveredMessages * 100) / totalSentMessages
      : 0;

  let totalOpenedMessagesPercentage =
    totalDeliveredMessages > 0
      ? (totalOpenedMessages * 100) / totalDeliveredMessages
      : 0;

  return (
    <Page fullWidth title="">
      <Card sectioned>
        {" "}
        <Stack alignment="center" distribution="equalSpacing">
          <Stack alignment="center">
            <img src={ChatWithUsIcon} />
            <Stack vertical spacing="extraTight">
              <TextStyle variation="strong">Schedule a Free Set Up call</TextStyle>
              <div
                  style={{
                    maxWidth: "680px",
                  }}
              >
                <TextStyle variation="subdued">
                  {" "}
                  Let us help you set up the abandoned cart recovery, order confirmation messages and the message templates using WhatsApp for your store.
                </TextStyle>
              </div>
            </Stack>{" "}
          </Stack>
          <Button
              primary
              onClick={() => {
                try {
                  window &&
                  window.open("https://zcal.co/rameshelamathi/whatsapp");
                } catch {}
              }}
          >
            {" "}
            Book a Free Set up Call{" "}
          </Button>
        </Stack>
      </Card>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            width: "50%",
            padding: "20px 20px 0px 0px",
          }}
        >
          {loading && (
            <Card title="" sectioned>
              <SkeletonBodyText lines={13} />
            </Card>
          )}
          {!loading && (
            <Card title="" sectioned>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  minHeight: "265px",
                }}
              >
                <div style={{ width: "50%" }}>
                  <Br height={25} />
                  <span>
                    <img
                      style={{
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      alt=""
                      width="50%"
                      height="50%"
                      src="../../Assets/illustrations/delivery-rate.svg"
                    />
                  </span>
                  <Br height={25} />
                  <div
                    style={{ display: "flex", justifyContent: "space-around" }}
                  >
                    <div>
                      <TextStyle variation="subdued">Delivery Rate</TextStyle>
                      <br />
                      <TextStyle variation="small">
                        <span style={{ color: "#008060" }}>
                          {totalDeliveredMessages} deliveries
                        </span>
                      </TextStyle>
                    </div>
                    <div>
                      <DisplayText size="medium">
                        {Math.ceil(totalDeliveredMessagesPercentage)}%
                      </DisplayText>
                    </div>
                  </div>
                </div>
                <div
                  style={{ borderRight: "1px solid rgba(124, 116, 116, 0.2)" }}
                ></div>
                <div style={{ width: "50%" }}>
                  <span
                    style={{
                      float: "right",
                    }}
                  >
                    <Link
                      removeUnderline
                      onClick={() => {
                        router.push("/message-history");
                      }}
                    >
                      <span style={{ color: "#008060" }}>
                        View message history
                      </span>
                    </Link>
                  </span>
                  <Br height={25} />
                  <img
                    style={{
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    alt=""
                    width="50%"
                    height="50%"
                    src="../../Assets/illustrations/read-rate.svg"
                  />
                  <Br height={25} />
                  <div
                    style={{ display: "flex", justifyContent: "space-around" }}
                  >
                    <span>
                      <TextStyle variation="subdued">Read Rate</TextStyle>
                      <br />
                      <TextStyle variation="small">
                        <span style={{ color: "#008060" }}>
                          {totalOpenedMessages} opens
                        </span>
                      </TextStyle>
                    </span>
                    <span>
                      <DisplayText size="medium">
                        {Math.ceil(totalOpenedMessagesPercentage)}%
                      </DisplayText>
                    </span>
                  </div>
                </div>
              </div>
            </Card>
          )}
        </div>
        <Dashboard />
      </div>

      {/* Modal with Form UI */}
      <Modal
        open={openModal}
        onClose=""
        title={<TextStyle variation="strong">Get Started</TextStyle>}
      >
        <Modal.Section>
          <Form onSubmit={handleSubmit}>
            <WhatsAppNumberForm
              phoneNumberError={phoneNumberError}
              whatsAppNumber={whatsAppNumber}
              change={(value) => {
                setWhatsAppNumber(value);
                setPhoneNumberError(false);
              }}
              selectChange={handleSelectChange}
              languageCode={languageCode}
              saving={saving}
              isHomePage={true}
            />
          </Form>
        </Modal.Section>
      </Modal>
      <Modal
        large
        open={openVideoModal}
        onClose={() => setOpenVideoModal(false)}
      >
        <Modal.Section>
          {playDemoVideo ? (
            <div style={{ padding: "15px" }}>
              <iframe
                style={{ borderRadius: "10px" }}
                width="100%"
                height="400"
                src="https://www.youtube.com/embed/yqMHzb0AbT4"
              ></iframe>
            </div>
          ) : (
            <div style={{ padding: "15px" }}>
              <iframe
                style={{ borderRadius: "10px" }}
                width="100%"
                height="400"
                src="https://www.youtube.com/embed/yqMHzb0AbT4"
              ></iframe>
            </div>
          )}
        </Modal.Section>
      </Modal>
      <Br height={5} />
      <Notice
        message={noticeMessage}
        show={showNotice}
        onClose={() => {
          setShowNotice(false);
        }}
        status={noticeType}
      />
      <div style={{ display: "flex" }}>
        <div>
          <Card sectioned>
            <Card.Section>
              <p className="title">Get started in 3 simple steps</p>
              <p>
                Win back lost sales through automated cart recovery campaign
                over WhatsApp. With over 75% of open rates, WhatsApp remains the
                only channel with higher engagement & conversion.
              </p>
              <div className="dashboard-steps">
                <div className="flex-row">
                  <div className="step-image">
                    <img
                      alt=""
                      width="100%"
                      height="100%"
                      src="../../Assets/get-started/create-automation.png"
                    />
                  </div>
                  <div className="w-100p m-l-10">
                    <p className="step-title">
                      Create Automation & set up message templates - 5 minutes
                    </p>
                    <p className="step-desc">
                      Go to Automations section and start adding a series of
                      message templates at well-timed intervals.
                    </p>
                  </div>
                </div>
                <div className="justify-center min-w">
                  <Button
                    onClick={() => {
                      router.push("/automations");
                    }}
                    primary
                  >
                    Get started
                  </Button>
                </div>
              </div>
              <div className="dashboard-steps">
                <div className="flex-row">
                  <div className="step-image">
                    <img
                      alt=""
                      width="100%"
                      height="100%"
                      src="../../Assets/get-started/enable-checkout.png"
                    />
                  </div>
                  <div className="w-100p m-l-10">
                    <p className="step-title">
                      Enable Checkout Opt-in - 5 minutes
                    </p>
                    <p className="step-desc">
                      Enable opt-in option for receiving messages over WhatsApp
                      at the Checkout settings of your store.
                    </p>
                  </div>
                </div>
                <div className="justify-center min-w">
                  <Button
                    onClick={() => {
                      router.push("/automations");
                    }}
                    primary
                  >
                    Get started
                  </Button>
                </div>
              </div>
              <div className="dashboard-steps">
                <div className="flex-row">
                  <div className="step-image">
                    <img
                      width="100%"
                      height="100%"
                      src="../../Assets/get-started/request-approval.png"
                      alt=""
                    />
                  </div>
                  <div className="w-100p m-l-10">
                    <p className="step-title">Request approval - 1 minute</p>
                    <p className="step-desc">
                      Don't worry. Its a compliance requirement from WhatsApp.
                      Within 24 hours (usually less), your request will be
                      processed and approved.
                    </p>
                  </div>
                </div>
                <div className="justify-center min-w">
                  <Button
                    onClick={() => {
                      router.push("/automations");
                    }}
                    primary
                  >
                    Get started
                  </Button>
                </div>
              </div>
            </Card.Section>
          </Card>
        </div>
        <div style={{ paddingLeft: "2%", width: "25%" }}>
          <Card sectioned>
            <p className="title">Still have questions?</p>
            <TextStyle variation="subdued">
              Watch this tutorials for detailed explanation
            </TextStyle>
            <Br height={20} />

            {loading && (
              <Card title="" sectioned>
                <SkeletonThumbnail size="large" />
              </Card>
            )}
            {!loading && (
              <div style={{ minHeight: "125px", position: "relative" }}>
                <img
                  style={{
                    minHeight: "150px",
                    minWidth: "200px",
                    width: "100%",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  preload="metadata"
                  onClick={() => {
                    /*setOpenVideoModal(true);
                    setPlayDemoVideo(true);
                    setPlayDemoVideoTwo(false);*/
                  }}
                  src="https://i.ytimg.com/vi/R5jIoLnL_nE/hqdefault.jpg"
                />
                <img
                  onClick={() => {
                    /*setOpenVideoModal(true);
                    setPlayDemoVideo(false);
                    setPlayDemoVideoTwo(true);*/
                  }}
                  height="50"
                  width="50"
                  style={{
                    position: "absolute",
                    top: "35%",
                    left: "40%",
                    cursor: "pointer",
                  }}
                  src="../../Assets/icons/Play-outlined.svg"
                ></img>
              </div>
            )}
            <Br height={10} />
            {loading && (
              <Card title="" sectioned>
                <SkeletonThumbnail size="large" />
              </Card>
            )}
            {!loading && (
              <div style={{ minHeight: "125px", position: "relative" }}>
                <img
                  style={{
                    minHeight: "150px",
                    minWidth: "200px",
                    width: "100%",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  preload="metadata"
                  onClick={() => {
                    /*setOpenVideoModal(true);
                    setPlayDemoVideo(true);
                    setPlayDemoVideoTwo(false);*/
                  }}
                  src="https://i.ytimg.com/vi/R5jIoLnL_nE/hqdefault.jpg"
                />
                <img
                  onClick={() => {
                    /*setOpenVideoModal(true);
                    setPlayDemoVideo(false);
                    setPlayDemoVideoTwo(true);*/
                  }}
                  height="50"
                  width="50"
                  style={{
                    position: "absolute",
                    top: "35%",
                    left: "40%",
                    cursor: "pointer",
                  }}
                  src="../../Assets/icons/Play-outlined.svg"
                ></img>
              </div>
            )}
          </Card>
        </div>
      </div>
      <Br height={100} />
    </Page>
  );
};

export default DashboardPage;
